import React from "react";
import SearchToggle from "./SearchToggle";
import SettingsToggle from "./SettingsToggle";

export default function HiddenTopbar() {
    return (
        <>
            <SearchToggle />
            <SettingsToggle />
        </>
    );
}
